import { createServerFn } from "@tanstack/react-start";
import { deleteCookie, getCookie } from "@tanstack/react-start/server";

export const getSessionCookie = createServerFn().handler(() => {
  getCookie("session");
});

export const deleteSessionCookie = createServerFn().handler(() => {
  deleteCookie("session");
});
